import { inject, Injectable } from '@angular/core';
import { Company } from '@bdeo-motor/smartphoto-entities';
import { ApiClientService } from './api-client.service';
import { AuthService } from './auth.service';
import { ISelector } from '@bdeo-platform/private-api';

export type SelectorItems =
  | (ISelector | undefined)[]
  | Partial<{
      [key: string]: unknown;
    }>;

@Injectable({
  providedIn: 'root'
})
export class CompanyRepositoryService {
  private readonly apiClientService = inject(ApiClientService);
  private readonly authService = inject(AuthService);

  public async getCompany(): Promise<Company> {
    const companyId = localStorage.getItem('company_id');

    if (!companyId) {
      throw new Error('No company id found');
    }

    const response = await this.apiClientService.getApiClient().motor.company.get({
      recordId: companyId,
      access_token: this.authService.getAccessToken()
    });

    const {
      data: { success, entity }
    } = response;

    if (!success) {
      throw new Error('Company not found');
    }

    return new Company(entity);
  }

  public async getSelector(name: string): Promise<SelectorItems> {
    const response = await this.apiClientService.getApiClient().motor.shared.selector.get({ type: name });

    const {
      data: { success, items }
    } = response;

    if (!success) {
      throw new Error('Selector not found');
    }

    return items;
  }
}
